
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_j1516_94",
  "grid": "awsui_grid_vj6p7_j1516_105",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_j1516_110",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_j1516_113",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_j1516_120",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_j1516_123",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_j1516_123",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_j1516_126",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_j1516_129",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_j1516_135",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_j1516_141",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_j1516_154",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_j1516_187",
  "root": "awsui_root_vj6p7_j1516_241",
  "tile-container": "awsui_tile-container_vj6p7_j1516_256",
  "has-metadata": "awsui_has-metadata_vj6p7_j1516_266",
  "selected": "awsui_selected_vj6p7_j1516_269",
  "disabled": "awsui_disabled_vj6p7_j1516_273",
  "columns": "awsui_columns_vj6p7_j1516_288",
  "column-1": "awsui_column-1_vj6p7_j1516_293",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_j1516_300",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_j1516_305",
  "column-2": "awsui_column-2_vj6p7_j1516_310",
  "column-3": "awsui_column-3_vj6p7_j1516_327",
  "column-4": "awsui_column-4_vj6p7_j1516_344",
  "control": "awsui_control_vj6p7_j1516_362",
  "no-image": "awsui_no-image_vj6p7_j1516_366",
  "image": "awsui_image_vj6p7_j1516_370"
};
  